<template>
    <div>
        <!-- <navbar-sas></navbar-sas> -->
        <div class="container pt-5">
            <div class="card p-4 border-radius">
                <h4 class=" text-center">Estado de tus solicitudes de pagos</h4>
                <div class="card mt-3 incard">
                    <div class="row p-4 justify-content-center">
                        <div class="col-3">
                              <label class="form-label">Número de importacion</label>
                              <input type="text" class="form-control" v-model="numeroImportacion">
                          </div>
                          <div class="col-3">
                              <label class="form-label">Fecha inicial</label>
                              <input type="date" class="form-control" v-model="FechaInicial">
                          </div>
                          <div class="col-3">
                              <label class="form-label">Fecha final</label>
                              <input type="date" v-model="FechaFinal" class="form-control">
                          </div>
                          <div class="col-3">
                              <button @click="statusCliente" type="button" class=" mt-4 btn btn-blue col-10">
                                  <i class="far fa-search"></i>
                                  Buscar
                              </button>
                          </div>
                    </div>
                </div>
                <div class="row" v-if="search">
                    <div class="col">
                        <button class="btn btn-success float-right" @click="downloadExcel">Descargar</button>
                    </div>
                </div>
                <div class="p-3 table-responsive" v-if="search">
                    <table class="table">
                        <thead>
                            <tr>
                            <th scope="col">Importacion</th>
                            <th scope="col">Fecha de Carga</th>
                            <th scope="col">Autorizacion</th>
                            <th scope="col">Tipo</th>
                            <th scope="col">Estatus</th>
                            <th scope="col">Monto</th>
                            <!-- <th scope="col">Fecha de Movimiento</th> -->
                            <th scope="col">Usuario</th>
                            <!-- <th scope="col">Acción</th> -->
                            </tr>
                        </thead>
                        <tbody v-for="(datos, i) in paginatedData" :key="i">
                            <tr>
                                <td >{{datos.Importacion}}</td>
                                <td>{{datos.FechaCarga}}</td>
                                <td>{{datos.Autorizacion}}</td>
                                <td>{{datos.Tipo}}
                                </td>
                                <td>{{datos.EstatusTxt}}
                                    <button @click="statusCancelada(datos.Importacion)" v-if="datos.EstatusTxt == 'Cancelada'" type="button" class="btn btn-link btn-sm">
                                        <i class="fas fa-info-circle"></i>
                                    </button>
                                </td>
                                <td>${{datos.Monto}}</td>
                                <!-- <td>{{datos.FechaMovimiento}}</td> -->
                                <td>{{datos.Analista}}</td>
                                <!-- <td v-if="datos.Tipo == 'Individual'">                                
                                    <button type="button" @click="validaImportacion(datos.Importacion)" style="background: #20add8; color: aliceblue;" class="btn btn-info m-1 btn-sm border-btn">
                                        Revisar
                                    </button>
                                    <button type="button" @click="info(datos.Importacion)" style="background: #1a61b4; color: aliceblue;" class="btn btn-sm ml-1 border-btn">
                                        Info
                                    </button>
                                    <button v-if="datos.Autorizacion" type="button" @click="comprobantePago(datos.Autorizacion)" style="background: #162585; color: aliceblue;" class="btn btn-sm mt-1 ml-1 border-btn">
                                        Comprobante
                                    </button>
                                </td> -->
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="row" v-if="search">
              <div class="col-12">
                <nav >
                  <ul class="pagination justify-content-center">
                    <li class="page-item" :class="{ disabled: currentPage === 1 }">
                      <button class="page-link" @click="changePage(currentPage - 1)">Previous</button>
                    </li>
                    <li
                      class="page-item"
                      v-for="page in totalPages"
                      :key="page"
                      :class="{ active: currentPage === page }"
                    >
                      <button class="page-link" @click="changePage(page)">{{ page }}</button>
                    </li>
                    <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                      <button class="page-link" @click="changePage(currentPage + 1)">Next</button>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
            </div>
        </div>
        <div class="foot">
            <p>&copy; 2024 Latino Seguros.</p>
        </div>
        <ErrorModal :errorMessage="errorMessage"/>
        <SuccessModal :successrMessage="successMessage"/>
        <ImportacionCanceladaModal
        :Importacion.sync="cancelada.importacion"
        :Tipo.sync="cancelada.tipo"
        :Motivo.sync="cancelada.motivo"
        :FechaI.sync="cancelada.fechaI"
        :FechaC.sync="cancelada.fechaC"
        />
        <RevisarDocumentosModal
        :listArchivos="listArchivos"/>
        <InfoInndividualModal
        :listDocs="listDocs"
        :mostrarDoc="CargarDocsIndividual"
        />
        <IframeModal
        :documento="base64"/>
        <Loading :isLoading="isLoading"/>
    </div>
</template>
<script>
import ErrorModal from "./Modals/errorModal.vue";
import Loading from './Tools/loading.vue'
import SuccessModal from "./Modals/successModal.vue";
import ImportacionCanceladaModal from "./Modals/importacionCanceladaModal.vue";
import RevisarDocumentosModal from "./Modals/revisarDocumentosModal.vue";
import InfoInndividualModal from "./Modals/infoInndividualModal.vue";
import IframeModal from "./Modals/iframeModal.vue";
import NavbarSas from './navbarSas.vue';
// import Loading from './Tools/loading.vue'

import * as XLSX from 'xlsx';

export default {
    components: { 
        Loading, 
        NavbarSas,
        SuccessModal,
        ErrorModal,
        ImportacionCanceladaModal,
        RevisarDocumentosModal,
        InfoInndividualModal,
        IframeModal
    }, 
    data(){
        return {
            numeroImportacion: '',
            FechaInicial: '',
            FechaFinal: '',
            errorMessage: '',
            successMessage: '',
            data: [],
            currentPage: 1,
            itemsPerPage: 10,
            search: false,
            isLoading: false,
            cancelada: {
                importacion: '',
                tipo: '',
                motivo: '',
                fechaI: '',
                fechaC: '',
            },
            listArchivos: [],
            listDocs: [],
            listGetFile: [],
            numOP: '',
            b64Comprobante: '',
            convertExcel: '',
            base64: '',
        }
    } ,
    computed: {
        totalPages() {
        return Math.ceil(this.data.length / this.itemsPerPage);
        },
        paginatedData() {
            const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.transformedData.slice(start, end);
        },
        transformedData() {
      return this.data.map((item) => ({
        ...item,
        EstatusTxt: this.mapEstatus(item.Estatus),
      }));
    },
    },
    methods:{
        getFormattedDate(date) {
            const d = new Date(date);
            let month = '' + (d.getMonth() + 1);
            let day = '' + d.getDate();
            const year = d.getFullYear();

            if (month.length < 2) month = '0' + month;
            if (day.length < 2) day = '0' + day;

            return [year, month, day].join('-');
        },
        getDefaultDates() {
            const today = new Date();
            const fifteenDaysAgo = new Date();
            fifteenDaysAgo.setDate(today.getDate() - 5);

            return {
                initialDate: this.getFormattedDate(fifteenDaysAgo),
                finalDate: this.getFormattedDate(today)
            };
        },
        changePage(page) {
            if (page > 0 && page <= this.totalPages) {
                this.currentPage = page;
            }
        },
        formatDate(dateString) {
            if (!dateString) return ''; // Manejar caso donde dateString es vacío o nulo
            const [year, month, day] = dateString.split('-');
            return `${day}-${month}-${year}`;
        },
        async statusCliente() {
            if (this.numeroImportacion == '' && this.FechaInicial == '' && this.FechaFinal == '') {
                this.$modal.show('error-modal');
                this.errorMessage = 'Debes ingresar la fecha inicial y fecha final o el número de importación.'
                return;
            }
        // this.ordenesPagos()
        this.isLoading = true
        this.respuesta = [];
        const payload = {
            metodo: "REPORTESTATUSCLIENTE",
            data: {
                RFC: localStorage.getItem('idRol') == '20056' ? localStorage.getItem('userId') : '',
                Importacion: this.numeroImportacion,
                FechaInicial: this.formatDate(this.FechaInicial),
                FechaFinal: this.formatDate(this.FechaFinal),
                NumFactura: '',
                CveProveedor: '',
                TipoCarga:"",
                IdConsulta: "",
                IdPerfil: localStorage.getItem('idRol'),
                IdAnalista: localStorage.getItem('idRol') == '20167' ? localStorage.getItem('profileId') : ''
            },
            };
            try {
            const response = await this.$store.dispatch("metodoPost", payload);
                if (response) {
                    const res = this.$store.getters.getRespuestaREST;
                    if (res.length == 0) {
                        this.$modal.show('error-modal');
                        this.errorMessage = 'No se encontraron resultados'
                        this.FechaInicial = ""
                        this.FechaFinal = ""
                        his.isLoading = false
                        return;
                    } else if (res[0].Importacion == "La consulta no generó datos"){
                        this.$modal.show('error-modal');
                        this.errorMessage = 'La consulta no generó datos'
                        this.FechaInicial = ""
                        this.FechaFinal = ""
                        his.isLoading = false
                        return;
                    }
                    this.data = res
                    this.search = true;
                    this.isLoading = false
                }
            } //Fin try
            catch (error) {
                console.log(error);
            }
            this.isLoading = false
        },
        transformData() {
            return this.data.map(item => ({
                ...item,
                Estatus: this.mapEstatus(item.Estatus)
            }));
        },
        mapEstatus(status) {
            const estatusMap = {
                "1": "Documentos Aceptados",
                "2": "Aceptada",
                "3": "Esperando Cambios",
                "4": "Docmentos Cargados",
                "5": "Cancelada",
                "6": "Autorizada",
                "7": "Pagada",
            };
            return estatusMap[status] || status; // Devuelve el status original si no se encuentra un mapeo
        },
        downloadExcel() {
            const transformedData = this.transformData();
            const ws = XLSX.utils.json_to_sheet(transformedData);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'Datos');

            // Generar el archivo Excel y descargarlo
            XLSX.writeFile(wb, 'Estado de Solicitudes de Pago SAS.xlsx');
        },
        async statusCancelada(importacion) {
            this.isLoading = true
            const payload = {
            metodo: "IMPORTACIONCANCELADA",
            data: {
                Importacion: importacion
            },
            };
            try {
            const response = await this.$store.dispatch("metodoPost", payload);
                if (response) {
                    const res = this.$store.getters.getRespuestaREST[0];
                    console.log(res);
                    this.cancelada.importacion = res.Importacion
                    this.cancelada.tipo = res.Tipo
                    this.cancelada.motivo = res.MotivoCancelacion
                    this.cancelada.fechaI = res.FechaImportacion
                    this.cancelada.fechaC = res.FechaCancelacion
                    this.$modal.show('cancelada');
                }
            } //Fin try
            catch (error) {
                console.log(error);
            }
            this.isLoading = false
        },
        async validaImportacion(importacion) {
            this.isLoading = true
            this.$modal.show('revisar-documento')
            const payload = {
            metodo: "VALIDAIMPORTACION",
            data: {
                Importacion: importacion
            },
            };
            try {
            const response = await this.$store.dispatch("metodoPost", payload);
                if (response) {
                    const res = this.$store.getters.getRespuestaREST[0];
                    console.log(res);
                    // this.factura = res.Factura
                    this.obtenerArchivosCargados(importacion, res.Factura)
                }
            } //Fin try
            catch (error) {
                console.log(error);
            }
        },
        async obtenerArchivosCargados(importacion, factura) {
            this.listArchivos = [];
            const payload = {
                metodo: "PPOBTENERARCHIVOSCARGADOSIND",
                data: {
                    Importacion: importacion,
                    NumFactura: factura,
                    IdTipoServicio:""
                },
                };
            try {
            const response = await this.$store.dispatch("metodoPost", payload);
                if (response) {
                    const res = this.$store.getters.getRespuestaREST[0];
                    console.log(res);
                    res.Archivos.map( doc => {
                        if(doc.EstatusArchivo == '2'){
                            if (doc.IdArchivo != '14') {
                                this.listArchivos.push(doc);
                            }
                        }
                    }) 
                    console.log(this.listArchivos);
                    if(res.Archivos.length == 0 || this.listArchivos.length == 0) {
                        this.$modal.show('error-modal');
                        this.errorMessage = 'No hay documentos faltantes.'
                        this.$modal.hide('revisar-documento')
                    }
                }
            } //Fin try
            catch (error) {
                console.log(error);
            }
            this.isLoading = false
        },
        async CargarDocs() {
            this.isLoading = true
            for (let i = 0; i < this.listArchivosValida.length; i++) {
            let nombreArchivo = this.listArchivosValida[i].NombreArchivo.split(".")
            const payload = {
                metodo: "GETFILE",
                data: {
                    psNombreArchivo: nombreArchivo[0],
                    psExtension: "." + nombreArchivo[1],
                    psIdOperacion: 5
                },
                };
                try {
                const response = await this.$store.dispatch("metodoPost", payload);
                    if (response) {
                        const res = this.$store.getters.getRespuestaREST;
                        this.listArchivosValida[i].archivoB64 = res
                        this.listGetFile.push(res)
                        
                    }
                } //Fin try
                catch (error) {
                    console.log(error);
                }
            }
            this.isLoading = false
        },
        async info(importacion){
            this.$modal.show('info-individual')
            this.isLoading = true
            const payload = {
                metodo: "PPOBTENERARCHIVOSCARGADOSIND",
                data: {
                    Importacion: importacion,
                    NumFactura: '',
                    IdTipoServicio:""
                },
                };
            try {
            const response = await this.$store.dispatch("metodoPost", payload);
                if (response) {
                    const res = this.$store.getters.getRespuestaREST[0];
                    this.listDocs = res.Archivos
                    console.log(this.listDocs);
                    // this.CargarDocs()
                    if(res.Archivos.length == 0) {
                        this.$modal.show('error-modal');
                        this.errorMessage = 'No hay información para mostrar.'
                        this.$modal.hide('info-individual')
                    }
                }
            } //Fin try
            catch (error) {
                console.log(error);
            }
            this.isLoading = false
        },
        async comprobantePago(autorizacion){
            this.isLoading = true
            const promise = new Promise(async( resolve, _) => {
                resolve(
                    this.ordenesPago(autorizacion)
                );
                });
                promise.then(async _ => {
                    this.isLoading = true
                    const payload = {
                    metodo: "COMPROBANTEPAGOSAS",
                    data: {
                        NumOp: this.numOP
                    },
                    };  
                    console.log(payload);
                    try {
                    const response = await this.$store.dispatch("metodoPost", payload);
                        if (response) {
                            const res = this.$store.getters.getRespuestaREST;
                            this.b64Comprobante = res.data;
                            this.convertExcel = 'data:text/pdf;base64,' + res.data;
                            var down = document.createElement('a');
                            down.href = this.convertExcel;
                            down.target = '_blank';
                            down.download = 'ComprobantePago.pdf'
                            document.body.appendChild(down);
                            down.click();
                            document.body.removeChild(down)
                        }
                    } //Fin try
                    catch (error) {
                        console.log(error);
                    }
                    this.isLoading = false
                }
            );
        },
        async ordenesPago(autorizacion){
            this.isLoading = true
            const payload = {
            metodo: "LISTARORDENESPAGOSSAS",
            data: {
                TipoCarga:"",
                FechaInicial:"",
                FechaFin:"",
                ClaveOrdenPago:"",
                NumAutorizacion: autorizacion
            },
            };  
            try {
            const response = await this.$store.dispatch("metodoPost", payload);
                if (response) {
                    const res = this.$store.getters.getRespuestaREST;
                    this.numOP = res[0].OrdenesPago[0].NumOP
                    console.log(res[0].OrdenesPago[0].NumOP);
                }
            } //Fin try
            catch (error) {
                console.log(error);
            }
            this.isLoading = false
        },
        async mostrarPDF(base64, nombre) {
            let extencion = nombre.split(".")[1]
            switch (extencion) {
                case 'jpg':
                    this.base64 = 'data:image/jpeg;base64,' + base64;
                    break;
                case 'pdf':
                    this.base64 = 'data:application/pdf;base64,' + base64;
                    break;
                case 'png':
                    this.base64 = 'data:image/png;base64,' + base64;
                    break;
                    case 'xml':
                    this.base64 = 'data:text/plain;base64,' + base64;
                    break;
                default:
                    break;
            }
            
        },
        async CargarDocsIndividual(nombre) {
            this.isLoading = true
            let nombreArchivo = nombre.split(".")
            const payload = {
            metodo: "GETFILE",
            data: {
                psNombreArchivo: nombreArchivo[0],
                psExtension: "." + nombreArchivo[1],
                psIdOperacion: 5
            },
            };
            try {
            const response = await this.$store.dispatch("metodoPost", payload);
                if (response) {
                    const res = this.$store.getters.getRespuestaREST;
                    this.mostrarPDF(res, nombre)
                    this.$modal.show('ver-documento')
                }
            } //Fin try
            catch (error) {
                console.log(error);
            }
            this.isLoading = false
        },
    },
    async mounted() {
        const defaultDates = this.getDefaultDates();
        this.FechaInicial = defaultDates.initialDate;
        this.FechaFinal = defaultDates.finalDate;
        await this.statusCliente();
        //this.FechaInicial = "";
        //this.FechaFinal = ""
        this.isLoading = false
    }

}
</script>
<style>
.border-btn{
    border-radius: 10px;
}
td {
  border-bottom: 2px solid #808080; /* Color gris */
}
.page-item.disabled .page-link {
  cursor: not-allowed;
}
.page-item.active .page-link {
  background-color: #003c71;
  border-color: #003c71;
  color: white;
}
.page-link {
  cursor: pointer;
  color: gray;
}
.incard{
    border-radius: 20px;
}
.border-radius{
    border-radius: 30px;
    min-height: 550px;
    box-shadow: 10px 10px 25px 4px rgba(0,0,0,0.1);
}
.foot {
    /* position: sticky; */
    background-color: #003c71;
    height: 60px;
    margin-top:10%
}
.foot p {
    padding: 20px;
    color: #ffffff;
    text-align: center;
}
.vm--modal {
    position: relative;
    overflow: hidden;
    box-sizing: border-box;
    background-color: white;
    border-radius: 30px !important;
    box-shadow: 0 20px 60px -2px rgba(27, 33, 58, 0.4);
}
.btn-blue{
    border-radius: 10px;
    background-image: linear-gradient(to right, #085da8, #003c71); /* Color de fondo verde */
    border: #003c71;
    color: white;
}
</style>